// Actions
export const LTRS__GET_SCHEDULE_EVENTS = 'LTRS__GET_SCHEDULE_EVENTS';
export const LTRS__GROUPED_BY_SCHEDULE = 'LTRS__GROUPED_BY_SCHEDULE';
export const LTRS__MUTATE_LOADING_STATUS = 'LTRS__MUTATE_LOADING_STATUS';
export const LTRS__MUTATE_SCHEDULE_EVENTS = 'LTRS__MUTATE_SCHEDULE_EVENTS';
export const LTRS__SCHEDULE_EVENTS_RECEIVED = 'LTRS__SCHEDULE_EVENTS_RECEIVED';
export const LTRS__UNAUTHENTICATED_ERROR_RECEIVED = 'LTRS__UNAUTHENTICATED_ERROR_RECEIVED';
